import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=3798527a&scoped=true&"
import script from "./EditContact.vue?vue&type=script&lang=js&"
export * from "./EditContact.vue?vue&type=script&lang=js&"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=3798527a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3798527a",
  null
  
)

export default component.exports